module.exports = __webpack_public_path__ + "b342e5cedcee6b73615c464adc11d359.svg";